/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import Layout from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
// eslint-disable-next-line import/no-cycle
import SettingsPageSidebar from "../../components/shared/SettingsPageSidebar";
// eslint-disable-next-line import/no-cycle
import Routes from "../../Routes";
import Store from "./store/Store";

const Settings = () => {
  const { path, url } = useRouteMatch();

  return (
    // <Layout className="flex flex-row ml-0px" style={{ minHeight: "100vh" }}>
    //   <Sider
    //     breakpoint="lg"
    //     collapsedWidth="0"
    //     onBreakpoint={(broken) => {
    //       console.log(broken);
    //     }}
    //     onCollapse={(collapsed, type) => {
    //       console.log(collapsed, type);
    //     }}
    //   >
    //     <SettingsPageSidebar />
    //   </Sider>

    //   <Layout className="flex-1 flex flex-col overflow-hidden bg-layout">
    //     <Switch>
    //       <Route exact path={path} component={Store} />
    //       {Routes.find((menu) =>
    //         // eslint-disable-next-line no-prototype-builtins
    //         menu.hasOwnProperty("subMenu")
    //       ).subMenu.map((subMenu) => (
    //         <Route
    //           exact
    //           key={subMenu.id}
    //           path={`${path}${subMenu.path}`}
    //           component={subMenu.component}
    //         />
    //       ))}
    //     </Switch>
    //   </Layout>
    // </Layout>
    <>
      <div className="grid grid-cols-1 md:grid-cols-12 grid-flow-row md:grid-flow-col min-h-screen min-w-full ">
            <div className="py-5 col-span-full md:col-span-2 h-auto md:min-h-screen md:bg-white sticky top-0 self-start"><SettingsPageSidebar /></div>
            <div className="col-span-full md:col-start-3 md:col-end-13">
            <Switch>
          <Route exact path={path} component={Store} />
          {Routes.find((menu) =>
            // eslint-disable-next-line no-prototype-builtins
            menu.hasOwnProperty("subMenu")
          ).subMenu.map((subMenu) => (
            <Route
              exact
              key={subMenu.id}
              path={`${path}${subMenu.path}`}
              component={subMenu.component}
            />
          ))}
        </Switch>
            </div>
      </div>
    </>
  );
};

export default Settings;
